//请自行添加语言资源
const reshipCornOrder = {
  plantName:'基地',
  planNo:"计划单",
  schNo:'车辆调度单',
  orderNo:'倒运单',
  vehicleNo:'车牌号',
  driverTel: '司机电话',
  currentNodeName: '订单运作状态',
  businessTypeName: '业务类型',
  goodsCategoryName: '货物类别',
  lotNo: '计划批次号',
  originStorageName: '出货库位',
  loadingTypeName: '装车工具',
  destStorageName: '收货库位',
  schSeq: '当日倒运顺序',
  reshipDate: '倒运日期',
  schStatusName: '状态',
  originLoadBeginTime: '装车开始时间',
  originLoadBeginUser: '装车开始操作人',
  originLoadEndTime: '装车结束时间',
  originLoadEndUser: '装车结束操作人',
  destUnloadBeginTime: '卸车开始时间',
  destUnloadBeginUser: '卸车开始操作人',
  destUnloadEndTime:'卸车结束时间',
  destUnloadEndUser: '卸车结束操作人',
  planWeight: '计划倒运重量(吨)',
  netWeight: '实际倒运量(吨)',
  msg:{
  }
};
export default reshipCornOrder



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornOrder/lang/reshipCornOrder.zh.js